import React from "react";
import { observer } from "mobx-react";
import { useTheme } from "@mui/material";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";
import { PodRevenueDashboardStore } from "../../../../stores/dashboards/PodRevenueDashboardStore";
import { formatPodCount } from "./podRevenueFormat";
import { PodRevenueSectionLabel } from "./PodRevenueSection";
import PodRevenueOrdersTable from "./PodRevenueOrdersTable";

/** Order-level listing (one row per order); click a row to open its products in the drawer. */
const PodRevenueLinesListing: React.FC<{ store: PodRevenueDashboardStore }> =
  observer(({ store }) => {
    const colors = useTheme().palette.customColors;
    return (
      <>
        <PodRevenueSectionLabel
          label="Orders"
          hint="One row per order with full order amounts (handling/shipping from POD services). Click a row to see its products."
          action={
            <CustomTypography
              variant="heading8"
              fontWeight={500}
              color={colors.mutedSlateText}
            >
              {formatPodCount(store.lines.total)} orders
            </CustomTypography>
          }
        />
        <PodRevenueOrdersTable
          onRowClick={(o) => void store.openOrder(o)}
          rows={store.lines.rows}
          page={store.lines.page}
          total={store.lines.total}
          onRetry={() => void store.fetchLines()}
          pages={store.lines.pages}
          loading={store.linesLoading}
          error={store.linesError}
          sortBy={store.lines.sortBy}
          sortType={store.lines.sortType}
          onSort={(s) => void store.setLinesSort(s)}
          onPage={(p) => void store.setLinesPage(p)}
        />
      </>
    );
  });

export default PodRevenueLinesListing;
